/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import setAuthToken from '../../helpers/setAuthToken';

export default Component => {
  return () => {
    const isAuth = useSelector(state => state.authState.isAuthenticated);
    const business = useSelector(state => state.authState.business);
    const token = useSelector(state => state.authState.token);
    const history = useHistory();

    const validate = () => {
      let path;
      if (isAuth && business.id) {
        path = '/finance';
      } else if (!isAuth) {
        path = '/start';
      }
      if (path) {
        history.push(path + history.location.search);
      }
    };

    useEffect(() => {
      if (token) {
        setAuthToken(token);
      }
      validate();
    }, []);

    useEffect(() => {
      if (token) {
        setAuthToken(token);
      }
      validate();
    });

    return <Component />;
  };
};
